/* eslint-disable no-useless-escape */
export type BrowserName =
  | 'edge'
  | 'yandexbrowser'
  | 'chrome'
  | 'crios'
  | 'firefox'
  | 'opera'
  | 'opera'
  | 'ie'
  | 'ie'
  | 'ie'
  | 'bb10'
  | 'android'
  | 'ios'
  | 'safari'
  | 'mozilla'
  | 'mobile'

interface Browser {
  name: BrowserName
  version: {
    major: number
    minor: number
    full: string
  }
}

export function detectBrowser(): Browser | undefined {
  const { userAgent } = window.navigator

  if (!userAgent) {
    return
  }

  const browsers: { name: BrowserName; pattern: RegExp }[] = [
    { name: 'edge', pattern: /Edge\/([0-9\._]+)/ },
    { name: 'yandexbrowser', pattern: /YaBrowser\/([0-9\._]+)/ },
    {
      name: 'chrome',
      pattern: /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    },
    { name: 'crios', pattern: /CriOS\/([0-9\.]+)(:?\s|$)/ },
    { name: 'firefox', pattern: /Firefox\/([0-9\.]+)(?:\s|$)/ },
    { name: 'mobile', pattern: /Mobile\/([0-9\.]+)(?:\s|$)/ },
    { name: 'opera', pattern: /Opera\/([0-9\.]+)(?:\s|$)/ },
    { name: 'opera', pattern: /OPR\/([0-9\.]+)(:?\s|$)$/ },
    { name: 'ie', pattern: /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/ },
    { name: 'ie', pattern: /MSIE\s([0-9\.]+).*Trident\/[4-7].0/ },
    { name: 'ie', pattern: /MSIE\s(7\.0)/ },
    { name: 'bb10', pattern: /BB10\sTouch.*Version\/([0-9\.]+)/ },
    { name: 'android', pattern: /Android\s([0-9\.]+)/ },
    { name: 'ios', pattern: /Version\/([0-9\._]+).*Mobile.*Safari.*/ },
    { name: 'safari', pattern: /Version\/([0-9\._]+).*Safari/ },
    { name: 'mozilla', pattern: /Mozilla\/([0-9\.]+)(?:\s|$)/ },
  ]

  return browsers
    .map(({ name, pattern }) => {
      if (pattern.test(userAgent)) {
        const match = pattern.exec(userAgent)
        const version = (match && match[1].split(/[._]/).slice(0, 3)) || []

        if (version.length && version.length < 3) {
          Array.prototype.push.apply(
            version,
            version.length === 1 ? [0, 0] : [0]
          )
        }

        return {
          name,
          version: {
            major: +version[0],
            minor: +version[1],
            full: version.join('.'),
          },
        }
      }
      return undefined
    })
    .filter(Boolean)
    .shift()
}
